import React from 'react';
import type { Herald } from '../api';
import { useMonsterTokenStyle } from '../utils/clientSettings';
import { getEntityAbilities } from '../utils/entityAbilities';
import { EntityDigitalCard } from './EntityDigitalCard';

type HeraldCardProps = {
  herald: Herald;
};

export const getHeraldImagePath = (heraldName: string) => `/Heralds/${encodeURIComponent(heraldName)}.jpg`;

export const HeraldCard: React.FC<HeraldCardProps> = ({ herald }) => {
  const artwork = useMonsterTokenStyle();
  const abilities = getEntityAbilities('Herald', herald.name);
  if (artwork === 'Digital' && abilities) return <EntityDigitalCard key={herald.name} kind="Herald" name={herald.name} abilities={abilities} />;
  return (
    <div className="herald-card">
      <img
        loading="lazy"
        src={getHeraldImagePath(herald.name)}
        alt={`Herald ${herald.name}`}
      />
    </div>
  );
};
